import { render } from "./PrivacyAndTerms.vue?vue&type=template&id=ed8e0dcc&scoped=true"
import script from "./PrivacyAndTerms.vue?vue&type=script&lang=js"
export * from "./PrivacyAndTerms.vue?vue&type=script&lang=js"

import "./PrivacyAndTerms.vue?vue&type=style&index=0&id=ed8e0dcc&scoped=true&lang=scss"
import "./PrivacyAndTerms.vue?vue&type=style&index=1&id=ed8e0dcc&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8e0dcc"]])

export default __exports__